interface IQuoteNewToolFurnitureSpecs {
  material?: string;
  onChangeSpec: (field: string, value: string) => void;
}

/**
 * Especificaciones técnicas para mobiliario dentro del formulario de creación de SKU desde cotización.
 */
const QuoteNewToolFurnitureSpecs = ({ material, onChangeSpec }: IQuoteNewToolFurnitureSpecs) => {
  return (
    <div className="specsGrid furnitureSpecs">
      <div className="specField">
        <label className="fieldLabel">Material*</label>
        <input
          className="specInput"
          placeholder="Ej. Madera"
          value={material ?? ''}
          onChange={e => onChangeSpec('material', e.target.value)}
        />
      </div>
    </div>
  );
};

export default QuoteNewToolFurnitureSpecs;
